export var Paths;

(function (Paths) {
  Paths["ListLatest"] = "/browse/whatsnew";
  Paths["ListPopular"] = "/browse/popular";
  Paths["GetFeatured"] = "/browse/featured";
})(Paths || (Paths = {}));